import { MenuItem } from '@szhsin/react-menu';
import React from 'react';
import { SettingsContext } from '../../../context/context';
import { useContext } from 'react';

const Personalize = () => {
  const { state, dispatch } = useContext(SettingsContext);
  return (<MenuItem
    type="checkbox"
    checked={state.personalize}
    onClick={e => dispatch({ type: 'personalize', payload: e.checked})}>
    Personalize
  </MenuItem>);
};

export default Personalize;
